export default {
  "HitPaw Online Audio Extractor": "Extracteur d'audio en ligne HitPaw",
  "Extract sound from videos with ease.": "Extraire le son des vidéos facilement.",
  "Select Audio Format": "Sélectionnez le format audio",
  "Extract Audio": "Extraire l'audio",
  "Extracting Audio": "Extraction de l'audio",
  "Extracted Successfully": "Extrait avec succès",
  "Extract New": "Extraire de nouveau",
  "Extraction Failed": "Échec de l'extraction",
  "Format": "Format",
};
